<nz-alert *ngIf="messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nz-alert>

<form nz-form [nzLayout]="'vertical'" (ngSubmit)="forgotPassword()" [formGroup]="resetForm" aria-labelledby="title">
  <div class="auth-wrapper">
    <p class="small-sub-title">Enter your email address and we'll send you a link to reset your password.</p>
    <nz-form-item>
      <nz-form-label nzRequired nzFor="email">Email</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Email must be a valid email address!">
        <input nz-input formControlName="email" id="email" fullWidth nzSize="large"
               autofocus [attr.aria-invalid]="f.email.invalid && f.email.touched ? true : null">
      </nz-form-control>
    </nz-form-item>

    <div nz-row>
      <div nz-col nzSpan="12" nzOffset="6">
        <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="submitted" id="reset-password-button"
                [disabled]="submitted || !resetForm.valid" [class.btn-pulse]="submitted" aria-label="Reset Password">
          Reset Password
        </button>
      </div>
    </div>
    <section class="sign-in-or-up" aria-label="Back to Sign In">
      <p><a class="text-link" [routerLink]="['/login']">Back to Sign In</a></p>
      <!--  <p>Don't have an account? <a [routerLink]="['/register']" class="text-link">Sign up</a></p>-->
    </section>
  </div>
</form>

